module.exports = __webpack_public_path__ + "static/work-bb3052e0298c228419fc02052004aca1.png";